import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import AppContext from '../../context/AppContext';

import Wrapper from './WrapperOLD';

import Button from '../../components/Button';
import { TemplateField } from '../../components/Attributes/Attributes_old';

import useSearchParams from '../../hooks/useSearchParams';
import useAsync from '../../hooks/useAsync';

import { resetPassword, verifyResetToken } from '../../api';
import { useApp } from '../../context/AppContextBeta';

const ResetPassword = () => {
	const navigate = useNavigate();
	const [formState, setFormState] = useState({});
	const [error, setError] = useState(null);
	const { token } = useSearchParams();
	const { login, isLoggingIn } = useApp();

	const {
		value: verifiedToken,
		status: verifying,
		execute: verifyToken,
	} = useAsync(verifyResetToken, {
		immediate: false,
		showNotification: {
			error: 'raw',
		},
	});

	const { execute: handlePasswordReset, status } = useAsync(resetPassword, {
		immediate: false,
	});

	useEffect(() => {
		if (token) {
			verifyToken({ token });
		}
	}, [token]);

	useEffect(() => {
		if (verifying === 'success' || verifying === 'error') {
			if (verifiedToken) {
			} else {
				navigate('/login/forgot');
			}
		}
	}, [verifiedToken, verifying]);

	if (!token || !verifiedToken) {
		return null;
	}

	const passwordsConfirmed = formState.password === formState.confirmPassword;

	return (
		<Wrapper title="Reset Password" message={error}>
			<div className="space-y-6">
				<TemplateField
					name={'Email'}
					value={verifiedToken?.email}
					disabled
					required
				/>
				<TemplateField
					name={'New Password'}
					type="password"
					value={formState?.password}
					required
					onChange={(key, value) =>
						setFormState({ ...formState, password: value })
					}
					autoFocus
				/>
				<TemplateField
					name={'Confirm New Password'}
					type="password"
					value={formState?.confirmPassword}
					required
					onChange={(key, value) =>
						setFormState({ ...formState, confirmPassword: value })
					}
				/>

				<div className="flex justify-between">
					<Button
						type="ghost"
						className="flex-shrink-0"
						onClick={() => navigate('/login')}
					>
						Go back
					</Button>
					<Button
						type="primary"
						className="flex-shrink-0"
						onClick={() =>
							handlePasswordReset(
								{
									password: formState.password,
									token: verifiedToken?.resetPasswordToken,
								},
								() =>
									login({
										email: verifiedToken?.email,
										password: formState?.password,
									}),
							)
						}
						disabled={!passwordsConfirmed}
					>
						{status === 'pending' || isLoggingIn
							? 'Loading...'
							: 'Reset Password'}
					</Button>
				</div>
			</div>
		</Wrapper>
	);
};

export default ResetPassword;
